var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t("overview.network.crews.header")))]),_c('vca-row',[_c('div',{staticClass:"clickable",on:{"click":_vm.navCrews}},[_vm._v(" "+_vm._s(_vm.$t("overview.network.crews.total"))+" ")]),_c('div',{staticClass:"bold"},[_vm._v(_vm._s(_vm.crews.length))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }